import * as React from "react";
const SvgBulletFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10" }));
export default SvgBulletFill;
